import React from "react";

const DuplicateRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.59995 10.6C2.82675 10.6 2.19995 9.97321 2.19995 9.20001V3.80001C2.19995 2.91636 2.9163 2.20001 3.79995 2.20001H9.19995C9.97315 2.20001 10.6 2.82681 10.6 3.60001",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.2 5.39999H7.00002C6.11637 5.39999 5.40002 6.11634 5.40002 6.99999V12.2C5.40002 13.0836 6.11637 13.8 7.00002 13.8H12.2C13.0837 13.8 13.8 13.0836 13.8 12.2V6.99999C13.8 6.11634 13.0837 5.39999 12.2 5.39999Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(DuplicateRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;